module.exports = __webpack_public_path__ + "static/media/modal_download.68d99614.png";